import { useAuthorized } from './useAuthorized';

export function Authorized({ children }: { children: JSX.Element }) {
  const authorized = useAuthorized();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return authorized ? children : null;
}
